/* fd-option-select-cards-20261031
   Turns the theme's "Lining and Edge Binding" dropdowns (fd-pdp-option--fields selects synced to VO) into image cards.
   The select stays in the DOM (visually hidden) and remains the source of truth: a card click sets select.value and
   dispatches "change", which the theme already syncs to the VO option. */
(function () {
  if (window.__fdOptionSelectCards20261031) return;
  window.__fdOptionSelectCards20261031 = true;

  var script = document.currentScript;
  var base = script && script.src ? script.src.replace(/[^/]*$/, '') : '';
  var IMAGES = {
    'Lining Type': {
      'Unlined': 'fd-hazel-pecan-lining-unlined.jpg',
      'White 90 gsm': 'fd-hazel-pecan-lining-white-90gsm.jpg',
      'Cotton 100% white 117 gsm': 'fd-opt-bamboo-lining-cotton-white-117gsm.webp',
      'Belgian Flax white': 'fd-opt-bamboo-lining-belgian-flax-white.webp',
      'Beige R06': 'fd-hazel-pecan-lining-beige-r06.jpg',
      'Khaki R08': 'fd-hazel-pecan-lining-khaki-r08.jpg',
      'White 140 gsm': 'fd-hazel-pecan-lining-white-140gsm.jpg',
      'Blackout White 250 gsm': 'fd-hazel-pecan-lining-blackout-white-250gsm.jpg',
      'Premium Woven Blackout white 350gsm': 'fd-opt-bamboo-lining-white-350gsm.webp',
      'Premium Woven Blackout 350gsm': 'fd-opt-bamboo-lining-white-350gsm.webp',
      'Blackout Coffee 180 gsm': 'fd-hazel-pecan-lining-blackout-coffee-180gsm.jpg'
    },
    'Edge Binding': {
      'Yes': 'fd-neutral-hazel-edge-yes.png',
      'No': 'fd-neutral-hazel-edge-no.png'
    }
  };
  var SELECTOR = 'fieldset.fd-pdp-option--fields select[data-fd-vo-option="Lining Type"], ' +
                 'fieldset.fd-pdp-option--fields select[data-fd-vo-option="Edge Binding"]';

  function render(select) {
    var map = IMAGES[select.getAttribute('data-fd-vo-option')] || {};
    var options = Array.prototype.slice.call(select.options).filter(function (o) { return o.value; });
    var mapped = options.filter(function (o) { return map[o.value]; }).length;
    var holder = select.__fdCards;
    if (!mapped) {               // fallback/placeholder options: keep the plain dropdown
      if (holder) { holder.remove(); select.__fdCards = null; }
      select.classList.remove('fd-optsel-hidden');
      return;
    }
    var signature = options.map(function (o) { return o.value; }).join('|');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'fd-optsel-cards';
      holder.setAttribute('role', 'radiogroup');
      var label = select.closest('label') || select;
      label.parentNode.insertBefore(holder, label.nextSibling);
      select.__fdCards = holder;
      select.addEventListener('change', function () { sync(select); });
    }
    if (holder.getAttribute('data-signature') !== signature) {
      holder.setAttribute('data-signature', signature);
      holder.innerHTML = '';
      options.forEach(function (o) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'fd-optsel-card';
        card.setAttribute('role', 'radio');
        card.setAttribute('data-value', o.value);
        if (map[o.value]) {
          var img = document.createElement('img');
          img.src = base + map[o.value];
          img.alt = '';
          img.loading = 'lazy';
          img.width = 94;
          img.height = 76;
          card.appendChild(img);
        } else {
          card.classList.add('fd-optsel-card--text');
        }
        var caption = document.createElement('span');
        caption.textContent = o.textContent.trim() || o.value;
        card.appendChild(caption);
        card.addEventListener('click', function () {
          if (select.value === o.value) return;
          select.value = o.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        holder.appendChild(card);
      });
    }
    select.classList.add('fd-optsel-hidden');
    sync(select);
  }

  function sync(select) {
    var holder = select.__fdCards;
    if (!holder) return;
    Array.prototype.forEach.call(holder.children, function (card) {
      var on = card.getAttribute('data-value') === select.value;
      card.classList.toggle('is-active', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(function (select) {
      render(select);
      if (!select.__fdObserved) {
        select.__fdObserved = true;
        new MutationObserver(function () { render(select); }).observe(select, { childList: true, subtree: true });
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
